import { Box, Stack, TextField, Typography } from "@mui/material";
import { luxonFormats } from "../../blockTypes";
import { requiredStyles } from "../../../../Common/styles/form";
import { DateTime } from "luxon";

type Props = {
  currentBlock: any;
};

const SignatureFieldPreview = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const isName = currentBlock?.config?.name;
  const isAddress = currentBlock?.config?.address;
  const isDate = currentBlock?.config?.date;
  const format = currentBlock?.config?.format;
  const isProvider = currentBlock?.config?.provider;

  return !isProvider ? (
    <Stack gap={1}>
      {label && (
        <Typography
          variant="body1"
          sx={{
            fontWeight: "medium",
            color: "text.primary",
          }}
        >
          {label}
        </Typography>
      )}
      {isName && (
        <Stack gap={1}>
          <Stack gap={1}>
            <Typography
              variant="subtitle1"
              fontWeight="regular"
              sx={requiredStyles}
            >
              First Name
            </Typography>
            <TextField name="firstName" fullWidth placeholder="First Name" />
          </Stack>
          <Stack gap={1}>
            <Typography
              variant="subtitle1"
              fontWeight="regular"
              sx={requiredStyles}
            >
              Last Name
            </Typography>
            <TextField name="lastName" fullWidth placeholder="Last Name" />
          </Stack>
        </Stack>
      )}
      {isAddress && (
        <Stack gap={1}>
          <Typography
            variant="subtitle1"
            fontWeight="regular"
            sx={requiredStyles}
          >
            Address
          </Typography>
          <TextField
            multiline
            rows={4}
            name="address"
            fullWidth
            placeholder="Address"
          />
        </Stack>
      )}
      {isDate && (
        <Stack gap={1}>
          <Typography variant="subtitle1" fontWeight="regular">
            Date
          </Typography>

          <TextField
            name="date"
            fullWidth
            placeholder="Date"
            defaultValue={DateTime.now().toFormat(luxonFormats?.[format]) || ""}
            InputProps={{
              readOnly: true,
            }}
          />
        </Stack>
      )}
      <Stack gap={1}>
        <Typography
          variant="subtitle1"
          fontWeight="regular"
          sx={requiredStyles}
        >
          Signature
        </Typography>
        <Box
          sx={{
            height: "96px",
            borderRadius: "8px",
            border: "1px solid #E5E7EB",
            width: "100%",
            p: 1.5,
          }}
        >
          <Typography variant="body1" sx={{ color: "#9CA3AF" }}>
            Signature
          </Typography>
        </Box>
      </Stack>
    </Stack>
  ) : null;
};
export default SignatureFieldPreview;
